// @core/api/endpoints/workflow/get_pipeline_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelinePolicyResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get pipeline policy
 * Returns a pipeline policy by ID.
 */
export async function GetPipelinePolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<PipelinePolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/pipeline-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<PipelinePolicyResponse>(requestPath, { ...requestOptions });
}
